import { useQuery } from "@tanstack/react-query";
import { fetchBlogList } from "../services/blogService";

function normalizeBlog(blog = {}, index = 0) {
  return {
    id: Number(blog?.blog_id || blog?.blogId || blog?.id || index + 1),
    serialNo: index + 1,
    title: blog?.title || "Article will be available soon.",
    description: blog?.short_description || blog?.description || "",
    isRead: Number(blog?.is_read ?? blog?.isRead ?? 0) === 1,
    isViewed: Number(blog?.is_viewed ?? blog?.isViewed ?? 0) === 1,
    readAt: blog?.read_at || blog?.readAt || "",
    viewedAt: blog?.viewed_at || blog?.viewedAt || "",
    isBookmarked: Number(blog?.bookmark_status ?? blog?.bookmarkStatus ?? 0) === 1,
    isLiked: Number(blog?.like_status ?? blog?.likeStatus ?? 0) === 1,
    likeCount: Number(blog?.total_likes ?? blog?.totalLikes ?? 0),
    viewCount: Number(blog?.total_views ?? blog?.totalViews ?? 0),
    commentCount: blog?.total_comments ?? blog?.totalComments ?? 0,
    categories: blog?.categories || "",
    createdAt: blog?.created_at || blog?.createdAt || "",
  };
}

function extractPagination(payload = {}) {
  const pagination = payload?.pagination || {};

  return {
    currentPage: Number(pagination?.currentPage || pagination?.current_page || 1),
    totalPages: Number(pagination?.totalPages || pagination?.total_pages || 1),
    totalRecords: Number(pagination?.totalRecords || pagination?.total_records || 0),
  };
}

export function useBlogList(params = {}, options = {}) {
  return useQuery({
    queryKey: ["dashboardBlogList", params],
    queryFn: async () => {
      const { payload } = await fetchBlogList(params);
      const pagination = extractPagination(payload);

      return {
        stateName: payload?.state_name || payload?.stateName || "",
        categoryName: payload?.category_name || payload?.categoryName || "Articles",
        blogs: (Array.isArray(payload?.blogs_list) ? payload.blogs_list : payload?.blogsList || []).map(normalizeBlog),
        pagination,
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
  });
}
